import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import {
  cityAsset,
  cityHref,
  cityOpen,
  configureCityManifest,
  MAP_CITY,
  openCities,
} from "./city.ts";
import { ENTRY, storedCity } from "./city-choice.ts";
import { ru } from "./i18n/ru.ts";
import { isPlacePath } from "./place/link.ts";
import "maplibre-gl/dist/maplibre-gl.css";
import "./styles.css";

const root = document.getElementById("root");
if (!root) throw new Error("#root not found");
const target = root;
async function boot() {
  if (!cityOpen(MAP_CITY, window.location)) {
    window.location.replace("/");
    return;
  }
  // The front door opens the visitor's city before anything loads (picked or found on a first visit).
  const chosen = ENTRY ? storedCity() : null;
  const home = openCities(window.location).find(
    (city) => city.id === chosen && city.id !== MAP_CITY.id,
  );
  if (home !== undefined) {
    window.location.replace(cityHref(home, window.location));
    return;
  }
  document.title = ru.cityTitle;
  const manifestLink = document.createElement("link");
  manifestLink.rel = "manifest";
  manifestLink.href = cityAsset("manifest.webmanifest");
  document.head.append(manifestLink);
  if (MAP_CITY.id !== "almaty") {
    const response = await fetch(cityAsset("city-manifest.json"));
    if (!response.ok) throw new Error("Missing city manifest");
    configureCityManifest(await response.json());
  }
  // `/about` is the "how it works" page, `/p` a point shared from the app (apps/ios/docs/SHARING.md);
  // everything else is the map. Vercel rewrites both to index.html (vercel.json), Caddy on kz1 serves
  // index.html for every unknown path.
  const path = window.location.pathname;
  const isAbout = path.replace(/\/+$/, "") === "/about";
  const Page = isAbout
    ? (await import("./ui/About.tsx")).About
    : isPlacePath(path)
      ? (await import("./ui/SharedPlace.tsx")).SharedPlacePage
      : (await import("./App.tsx")).App;
  createRoot(target).render(
    <StrictMode>
      <Page />
    </StrictMode>,
  );
}
void boot().catch(() => {
  target.textContent = ru.cityLoadError;
});
